<template>
  <div class="pt-3" v-if="user.id">
    <div class="alert alert-warning">
      แนะนำ: การแจ้งเติมเพื่อความสะดวกและ รวดเร็ว <u>กรุณาใช้เลขบัญชีเดียวกับบัญชีแจ้งถอน</u> ของท่านในการโอนเงิน ในกรณีที่ชื่อบัญชีฝาก
      ไม่ตรงกับชื่อบัญชีถอน ท่านต้องส่งหลักฐานเพิ่มเติม ทั้งนี้ทั้งนั้นขึ้นอยู่กับนโยบายของแต่ละเอเย่นต์
    </div>
    <div class="alert alert-info" v-html="messages" v-if="messages"></div>

    <div class="alert alert-warning" v-if="alreadyHavingPromotion">คุณมีโปรโมชั่นชิปฟรีที่ได้จากระบบ ในกรณีที่คุณทำการฝากเงินมา จะยังคงติด เทิร์นโอเวอร์ แนะนำว่าคุณควรจะทำเทิร์นโอเวอร์ให้ครบก่อน</div>
    <div v-if="disallowDeposit">
      <div class="ibox float-e-margins">
        <div class="ibox-content">
          <div class="alert alert-danger">คุณมีโปรโมชั่นชิปฟรีที่ได้จากระบบ ต้องทำเทิร์นโอเวอร์ให้ครบ หรือว่าใช้ให้หมดก่อนถึงจะฝากเงินเข้ามาได้</div>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- Start Content -->
      <div class="card mb-4">
        <div class="card-body alert alert-danger">
          <p class="mb-0" v-html="$t('messages.deposit_guild_condition',{minute:timeDepositIntelligent/60})">
          </p>
        </div>
      </div>
      <!-- End Content -->
      <!-- Start Form -->
      <div class="d-flex mb-3">
        <div class="">
          <h4 class="mb-0 text-primary">{{ $t('form.title.select_account_deposit') }}</h4>
        </div>
      </div>
      <div class="form-group">
        <div class="row mb-3 u-select-none" :class="[{ 'has-error' : errors.has('bank_code') }]">
          <div class="col-xs-6 col-md-4 col-lg-2 bank-wrapper" v-for="(value, key) of accounts" :key="key">
            <div :class="['card card-bank flex-row mb-3', { 'active' : chooseBank===key }]" @click="handleOnClickBank(key)">
              <div class="card-body flex-shrink-1 card-bank-image">
                <i :class="['thbanks','ico', 'thbanks thbanks-' + key]"></i>
              </div>
              <div class="card-body w-100 p-3 d-flex align-items-center">
                <h4 class="mb-0 d-flex">{{ value }}</h4>
              </div>
            </div>
          </div>
          <input type="radio" name="bank_code" v-model="chooseBank" class="hide form-control" v-validate="'required'"/>
          <div v-show="errors.has('bank_code')" class="help-block text-center">
            {{ errors.first('bank_code') }}
          </div>
        </div>
      </div>

      <div class="row mb-4" v-if="hasAccounts">
        <div class="col-12 col-lg-12">
          <div class="card border-0 mb-4 mb-lg-0">
            <div class="card-body my-1 mx-3">
              <div class="form-group row">
                <label class="col-sm-2 col-xl-3 col-form-label text-right">{{ $t('messages.remaining_chip') }}</label>
                <div class="col-sm-8 col-xl-7">
                  <ul class="list-inline form-control-plaintext">
                    <li class="list-inline-item">
                      <i class="fas fa-coins mr-2 text-primary"></i>{{ $t('messages.credit_chip') }} <strong>{{ getCreditChip(user) | float }}</strong>
                    </li>
                    <li class="list-inline-item">
                      <i class="fal fa-usd-circle mr-2 text-primary"></i>{{ $t('messages.rolling_chip') }} <strong>{{ getRollingChip(user) | float }}</strong>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="form-group row" :class="[{ 'has-error' : errors.has('deposit_amount') }]">
                <label class="col-sm-2 col-xl-3 col-form-label text-right">{{ $t('form.amount') }}</label>
                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7">

                  <div class="input-group">
                    <input type="tel" id="deposit_amount" :class="['form-control']" name="deposit_amount" autocomplete="off" placeholder="eg. 1000" v-model="depositAmount" v-validate="'required|min_value:10'" :disabled="isPendingMode()">
                    <span class="input-group-btn"><button class="btn btn-primary" @click="handleOnClickDepositIntelligent" :disabled="isPendingMode()">{{ $t('form.request.ok') }}</button></span>
                  </div>
                  <div v-show="errors.has('deposit_amount')" class="help-block">
                    {{ errors.first('deposit_amount') }}
                  </div>
                </div>
              </div>

              <div v-if="isPendingMode()">
                <div class="form-group row text-center">
                  <div class="col-sm-2 col-xl-3 col-form-label text-right">
                  </div>
                  <div class="col-sm-6">
                    <h2>{{ $t('messages.depositInMinute', {minute: timeDepositIntelligent / 60}) }}</h2>
                    <h1 class="text-danger" v-if="(minutes + remainingSeconds)">{{padStart(hours, 2)}}:{{padStart(minutes, 2)}}:{{padStart(remainingSeconds, 2)}}</h1>
                    <h1 v-else>--:--:--</h1>
                  </div>
                </div>

                <div class="form-group row text-center">
                  <div class="col-sm-2 col-xl-3 col-form-label text-right">
                  </div>
                  <div class="col-sm-6">
                    <h2>{{ $t('messages.balanceMustBeDeposit') }} </h2>
                    <h1 class="text-success">{{ depositIntelligent.amount | float }}</h1>
                    <h3 class="text-danger" v-if="allowDepositIntelligent">{{ $t('messages.specify_decimal') }}</h3>
                  </div>
                </div>

                <div class="form-group row" v-if="qrCode">
                  <label class="col-sm-2 col-xl-3 col-form-label text-right">{{ $t('form.title.transfer_with_qrcode') }}</label>
                  <div class="col-sm-6 col-xl-6 text-center">
                    <a :ref="qrCode"><img :src="qrCode"/></a>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-2 col-xl-3 col-form-label text-right">{{ $t('messages.specify_bankAccount') }}</label>
                  <div class="col-sm-6 col-xl-6">

                    <div :class="['card card-bank flex-row mb-3 active']">
                      <div class="card-body flex-shrink-1 card-bank-image">
                        <i :class="['thbanks', 'thbanks-' + depositIntelligent.bankInfo.bank_code]"></i>
                      </div>
                      <div class="card-body w-100 p-3">
                        <h4 class="mb-0">{{ depositIntelligent.bankInfo.name }}</h4>
                        <p class="text-sm mb-0">{{ $t('form.acc_name') }} {{ depositIntelligent.bankInfo.account_name }}</p>
                        <p class="text-sm mb-0">{{ $t('form.acc_no') }} {{ depositIntelligent.bankInfo.account_number }}</p>
                        <button class="btn btn-sm btn-primary text-gray-900" @click="clipboard(depositIntelligent.bankInfo.account_number)">
                          <i class="fa fa-copy"> Copy</i></button>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="form-group row" :class="[{ 'has-error' : errors.has('date') }]">
                  <label class="col-sm-2 col-xl-3 col-form-label text-right">{{ $t('form.date') }}</label>
                  <div class="col-sm-10 col-md-6 col-lg-7 col-xl-6">
                    <div class="datetime-wrapper input-group">
                      <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                      <date-picker v-model="currentDate" :config="options.date" name="date" v-validate="'required|date_format:DD/MM/YYYY'"></date-picker>
                    </div>
                    <div v-show="errors.has('date')" class="help-block">
                      {{ errors.first('date') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row" :class="[{ 'has-error' : errors.has('time') }]">
                  <label class="col-sm-2 col-xl-3 col-form-label text-right">{{ $t('form.time') }}</label>
                  <div class="col-sm-10 col-md-6 col-lg-7 col-xl-6">
                    <div class="datetime-wrapper input-group">
                      <span class="input-group-addon"><i class="fa fa-clock-o"></i></span>
                      <date-picker v-model="currentTime" :placeholder="$t('messages.specify_transfer_time')" :config="options.time" name="time" v-validate="'required|date_format:HH:mm'"></date-picker>
                    </div>
                    <div v-show="errors.has('time')" class="help-block">
                      {{ errors.first('time') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-xl-3 col-form-label text-right">{{ $t('form.remark') }}</label>
                  <div class="col-sm-10 col-md-6 col-lg-7 col-xl-6">
                    <textarea class="form-control" rows="4" :placeholder="$t('form.remark')" v-model="remark"></textarea>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-lg-offset-2 col-sm-10 col-md-6 col-lg-7 col-xl-6">
                    <button class="btn btn-primary" @click="handleOnClickSubmit">{{ $t('form.request.deposit') }}</button>
                    <button class="btn btn-outline-primary mr-2" type="reset" @click="handleOnClickCancel">{{ $t('form.cancel') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div v-else>
        <div class="alert alert-danger">{{ $t('form.request.bank.notfound') }}</div>
      </div>
      <!-- End Form -->
    </div>
  </div>
</template>

<script>
  import apiRequest from '../api/request'
  import {mapActions} from 'vuex'
  import requestInterval from 'request-interval'
  import moment from 'moment'
  import {mapGetters} from 'vuex'
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
  const QRCode = require('qrcode')

  const Visibility = require('visibilityjs')
  let timer = undefined

  export default {
    name: 'request-deposit',
    props: {
      userId: {
        type: Number,
      }
    },
    data() {
      return {
        remark: '',
        messages: null,
        depositAmount: null,
        chooseBank: null,
        accounts: {},
        user: {},
        disallowDeposit: null,
        alreadyHavingPromotion: null,
        currentDate: null,
        currentHour: null,
        currentMinutes: null,
        currentTime: null,
        image: null,
        fileUpload: null,
        countdown: 0,
        days: 0,
        hoursLeft: 0,
        hours: 0,
        minutesLeft: 0,
        minutes: 0,
        remainingSeconds: 0,
        timeInSeconds: 0,
        depositIntelligent: {},
        allowDepositIntelligent: false,
        timeDepositIntelligentReset: false,
        timeDepositIntelligent: false,
        qrCode: false,
        qrTransfer: false,
        datetimePicker: {
          date: moment().format('DD/MM/YYYY'),
          time: moment().format('HH:mm'),
        },
        channels: {
          depositIntelligent: null
        },
        options: {
          date: {
            format: 'DD/MM/YYYY',
            // debug: true,
          },
          time: {
            format: 'HH:mm',
            // debug: true,
          }
        }
      }
    },
    components: {},
    mounted() {

      Visibility.change(function (e, state) {
        this.loadData()
      }.bind(this))
      this.loadData()

      this.channels.depositIntelligent = pusher.subscribe(`request-deposit-intelligent.${this.userId}`)
      this.channels.depositIntelligent.bind('user-receive', (data) => {
        window.location = '/member/request'
      })
    },
    computed: {
      hasAccounts() {
        return _.size(this.accounts)
      }
    },
    created() {
    },
    methods: {
      ...mapActions('directMessage', ['pushMessage']),
      loadData() {
        apiRequest.getDeposit((response) => {

          this.accounts = _.get(response, 'data.accounts')
          this.user = _.get(response, 'data.authUser')
          this.messages = _.get(response, 'data.message')
          this.disallowDeposit = _.get(response, 'data.disallowDeposit')
          this.alreadyHavingPromotion = _.get(response, 'data.alreadyHavingPromotion')
          this.currentDate = _.get(response, 'data.currentDate')
          this.currentHour = _.get(response, 'data.currentHour')
          this.currentMinutes = _.get(response, 'data.currentMinutes')
          this.depositIntelligent = _.get(response, 'data.depositIntelligent')
          this.countdown = _.get(response, 'data.countdown')
          this.timeInSeconds = _.get(response, 'data.countdown')
          if (this.countdown > 0) {
            this.depositAmount = _.get(response, 'data.depositIntelligent.amount')
            this.chooseBank = _.get(response, 'data.depositIntelligent.bankInfo.bank_code')
          } else {
            this.depositAmount = null
          }
          this.allowDepositIntelligent = _.get(response, 'data.allowDepositIntelligent')
          this.timeDepositIntelligentReset = _.get(response, 'data.timeDepositIntelligentReset')
          this.timeDepositIntelligent = _.get(response, 'data.timeDepositIntelligent')
          this.qrTransfer = _.get(response, 'data.qrTransfer')
          this.countDownTimeSync()
        }, (error) => {
          this.handleErrorMessage(error)
        })
      },
      handleOnClickSubmit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            let bodyFormData = new FormData()
            let time = _.clone(this.currentTime)
            time = time.split(':')
            bodyFormData.append('amount', this.depositAmount)
            bodyFormData.append('bank_id', this.chooseBank)
            bodyFormData.append('remark', this.remark)
            bodyFormData.append('check_date', this.currentDate)
            bodyFormData.append('check_hours', _.get(time, '0'))
            bodyFormData.append('check_minutes', _.get(time, '1'))
            bodyFormData.append('transfer_slip', this.fileUpload)

            apiRequest.postDeposit((response) => {
                window.location = '/member/request'
              },
              (error) => {
                this.handleErrorMessage(error)
              }, bodyFormData)
          }
        })
      },
      handleOnClickDepositIntelligent() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            const data = {
              'amount': this.depositAmount,
              'bank_code': this.chooseBank,
            }
            apiRequest.postDepositIntellient((response) => {
                this.loadData()
              },
              (error) => {
                this.handleErrorMessage(error)
              }, data)
          }
        })
      },
      handleOnClickCancel() {

        if (this.countdown > this.timeDepositIntelligentReset) {
          this.$notify.error({
            title: this.$t('messages.error'),
            message: this.$t('messages.timeDepositIntelligentReset', {minute: parseInt(this.timeDepositIntelligentReset / 60)}),
            duration: 6000
          })

        } else {
          apiRequest.postDepositIntellientReseet((response) => {
              this.loadData()
            },
            (error) => {
              this.handleErrorMessage(error)
            })
          this.depositAmount = null
          this.remark = ''
//        this.$refs.uploadImage.value = ''
          this.handleOnClickRemoveFile()
        }
      },
      getCreditChip(data) {
        return _.get(data, 'credit.credit_chip', 0)
      },
      getRollingChip(data) {
        return _.get(data, 'credit.rolling_chip', 0)
      },

      createImage(file) {
        var image = new Image()
        var reader = new FileReader()
        var vm = this

        reader.onload = (e) => {
          vm.image = e.target.result
        };
        reader.readAsDataURL(file)
      },
      handleOnClickUpload() {
//        this.$refs.uploadImage.click()
      },
      handleOnUploadImage(e) {
        var files = e.target.files || e.dataTransfer.files
        if (!files.length)
          return
        this.fileUpload = files[0]
        this.createImage(files[0])
      },
      handleOnClickRemoveFile() {
        this.fileUpload = null
        this.image = null
//        this.$refs.uploadImage.value = ''
      },
      handleOnClickBank(key) {
        if (this.countdown > 0) {
        } else {
          this.chooseBank = key
        }
      },
      isPendingMode() {
        return this.countdown > 0
      },
      countDownTimeSync() {
        if (!_.isUndefined(timer)) requestInterval.clear(timer)
        const timeInSeconds = this.timeInSeconds
        this.countdown = parseInt(timeInSeconds)

        timer = requestInterval(1000, () => {
          this.countdown--
          this.days = Math.floor(this.countdown / 24 / 60 / 60)
          this.hoursLeft = Math.floor((this.countdown) - (this.days * 86400))
          this.hours = Math.floor(this.hoursLeft / 3600)
          this.minutesLeft = Math.floor((this.hoursLeft) - (this.hours * 3600))
          this.minutes = Math.floor(this.minutesLeft / 60)
          this.remainingSeconds = this.countdown % 60
          if (this.countdown === 0) {
            this.days = 0
            this.hoursLeft = 0
            this.hours = 0
            this.minutesLeft = 0
            this.minutes = 0
            this.remainingSeconds = 0
            this.handleOnClickCancel()
            this.loadData()
            requestInterval.clear(timer)

          }
        })
      },
      getSuccessMessage() {
        //
      },
      handleErrorMessage(response) {
        const status = _.get(response, 'response.status')
        let message = null
        let title = this.$t('messages.error')

        switch (status) {
          case 400:
            message = _.get(response, 'response.data.message', 'Something went wrong')
            this.$notify.error({
              title: title,
              message: message,
              duration: 6000
            })
            break
          case 401:
            message = _.get(response, 'response.statusText', 'Something went wrong')
            this.$notify.error({
              title: title,
              message: message,
              duration: 6000
            })
            window.location = '/logout'
            break
          case 422:
            message = _.get(response, 'response.data.errors[0].message', 'Something went wrong')
            this.$notify.error({
              title: title,
              message: message,
              duration: 6000
            })
            break
          case 500:
            message = _.get(response, 'response.data.error.message', 'Something went wrong')
            this.$notify.error({
              title: title,
              message: message,
              duration: 6000
            })
            break
          default:
            message = _.get(response, 'response.statusText', 'เกิดข้อผิดพลาด! กรุณารอซักครูเพื่อดำเินการอีกครั้ง')
            this.$notify.error({
              title: title,
              message: message,
              duration: 6000
            })
            break
        }
      },
      padStart(value, length = 10, replace = 0) {
        return _.padStart(value, length, replace)
      },
      clipboard(message) {
        const vm = this
        this.$copyText(message).then(function (e) {
          vm.$notify.success({
            title: '',
            message: vm.$t('messages.copied'),
            duration: 6000
          })
        }, function (e) {
        })
      },
      generateQRCode() {
        if (!this.qrTransfer) {
          this.qrCode = false
          return
        }
        var opts = {
          errorCorrectionLevel: 'H',
          type: 'image/jpeg',
          rendererOpts: {
            quality: 0.3
          }
        }
        var vm = this
        QRCode.toDataURL(this.qrTransfer, opts, function (err, url) {
          if (err) throw err
          vm.qrCode = url
        })
      }
    },
    watch: {
      'qrTransfer': function () {
        this.generateQRCode()
      }
    }
  }
</script>

<style>
  .card-bank {
    cursor: pointer;
    padding: 20px 0 10px;
    text-align: center;
    border: 1px solid #efefef;
    border-radius: 3px;
    transition: background 0.25s;
  }
  .card-bank:hover {
    background: #f9f9f9;
    border-color: #e9e9e9;
  }
  .card-bank.active {
    background: #f9f9f9;
    border-color: green;
  }
  .u-select-none {
    user-select: none;
  }
  .bank-wrapper {
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/MemberRequestDeposit.vue